const ElevenThree = ({ elevenThree }) => {
    return (
        <div className='time-stamp space-y-2'>
            <label className='morning'> 11AM -3PM <span>&#8594;   {elevenThree.pct + "%"}</span></label>
            <div></div>
            <div><span className='font-semibold'>Total Sales:</span> {elevenThree.total_count} X <span>{elevenThree.total_sales}</span></div>
            <div className='numbers space-y-2'>
                <div><span>Dine-In : </span> {elevenThree.dinein_sales === 'None' ? "-" : <>{elevenThree.dinein_count} X {elevenThree.dinein_sales}</>}</div>
                <div><span>Order :</span>{elevenThree.tab_sales === 'None' ? "-" : <>{elevenThree.tab_count} X {elevenThree.tab_sales}</>}</div>
            </div>
        </div>
    )
}

export default ElevenThree